import { Injectable, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ComponentStore, OnStoreInit } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { selectPortfolioPropertyItem } from '@platform/portfolio/selectors/portfolio-property.selector';
import { selectPortfolioSmartSearch } from '@platform/portfolio/selectors/portfolio-smart-search.selector';
import { switchMap } from 'rxjs/operators';

interface PortfolioCardDetailState {
  propertyId: string;
  smartSearchId: string;
}

const initialPortfolioCardDetailState: PortfolioCardDetailState = {
  propertyId: null,
  smartSearchId: null,
};

@Injectable()
export class PortfolioCardDetailStore extends ComponentStore<PortfolioCardDetailState> implements OnStoreInit {
  protected readonly globalStore = inject(Store);
  protected readonly route = inject(ActivatedRoute);

  constructor() {
    super(initialPortfolioCardDetailState);
  }

  ngrxOnStoreInit(): void {
    this.setPortfolioId(this.route.snapshot.params.propertyId);
    this.setSmartSearchId(this.route.snapshot.params.smartSearchId);
  }

  // SELECTORS ---------------------------------------------------------------------------------------------------------
  readonly propertyPortfolioItem$ = this.select(({ propertyId }) => propertyId).pipe(
    switchMap((propertyId) => this.globalStore.select(selectPortfolioPropertyItem(propertyId))),
  );

  readonly smartSearchItem$ = this.select(({ smartSearchId }) => smartSearchId).pipe(
    switchMap((smartSearchId) => this.globalStore.select(selectPortfolioSmartSearch(smartSearchId))),
  );

  // EFFECTS -----------------------------------------------------------------------------------------------------------

  // UPDATERS ----------------------------------------------------------------------------------------------------------
  private setPortfolioId = this.updater(
    (state, propertyId: string): PortfolioCardDetailState => ({
      ...state,
      propertyId,
    }),
  );

  private setSmartSearchId = this.updater(
    (state, smartSearchId: string): PortfolioCardDetailState => ({
      ...state,
      smartSearchId,
    }),
  );
}
